import { createI18n } from "vue-i18n";
import { getTranslations, QFood } from "@q-food/q-food";

const i18n = createI18n({
	/**
	 * Composition mode. Legacy mode installs a global mixin whose `unmounted` hook dereferences
	 * `this.$i18n` without a null check (vue-i18n.mjs:1591 vs :1613), which throws
	 * "can't access property __disposer, _vueI18n is undefined" whenever a component is torn down
	 * without it — constantly during HMR. That mixin is only installed for the legacy API.
	 *
	 * `globalInjection` keeps `$t` and `$n` available in templates, which is all this app uses of the
	 * global helpers; composition mode exposes t, rt, d, n, tm and te.
	 */
	legacy: false,
	globalInjection: true,
	locale: "nl",
	messages: {},
});

QFood.BASE_URL = `${window.location.protocol}//${window.location.host}`;
getTranslations("nl").then((translations) => {
	i18n.global.setLocaleMessage("nl", translations);
});

function translate(key: string, args: Array<string> = []) {
	return i18n.global.t(key, args);
}

export { i18n, translate };
export default i18n;
